<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormPhoto
      :Photo="editPhoto"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormPhoto from '../components/FormPhoto.vue';

export default {
  components: {
    FormPhoto,
  },
  name: 'EditPhoto',
  module: 'Cms',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing Photo. Default to {}.
      */
      editPhoto: {},
      /**
       * Query Id for Photo
       */
      photoId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('photos', ['photos', 'photo']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.photoId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_photo(this.photoId);
      this.editPhoto = this.photo;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('photos', ['LOAD_photo', 'CREATE_photo', 'UPDATE_photo']),
    /** Method used to save the item
     */
    async save(photo) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_photo(photo);
      } else {
        await this.UPDATE_photo(photo);
      }
      this.isSaving = false;
      this.$router.push({ name: 'photo-ListPhoto' });
    },
  },
};
</script>

<docs>
# EditPhoto example

'''js
<EditPhoto :Photo="Photo" />
'''
</docs>
